import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { initSentry } from "./observability/sentry";
import "./styles/globals.css";

initSentry();

const root = document.getElementById("root");
if (!root) {
  throw new Error("#root elementi bulunamadı — index.html hasarlı");
}

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
